var _excluded = ["size", "checked", "disabled", "error", "children", "className", "data-qa", "isAdaptive", "mobileMedia"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { joinCn } from "@ati/uti";
var Checkbox = _ref => {
  var {
      size = "medium",
      checked,
      disabled,
      error,
      children,
      className,
      "data-qa": dataQa = "checkbox",
      isAdaptive = false,
      mobileMedia = "541"
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("label", {
    className: joinCn("glz-checkbox", error && !disabled && "glz-is-error", "glz-is-".concat(size), isAdaptive && "glz-is-adaptive-".concat(mobileMedia), className),
    "data-qa": dataQa
  }, /*#__PURE__*/React.createElement("input", _extends({}, props, {
    type: "checkbox",
    checked: checked,
    disabled: disabled
  })), /*#__PURE__*/React.createElement("span", null, children));
};
export default Checkbox;